// extracted by mini-css-extract-plugin
export default {"container":"H1-z","heading":"I1-z","links":"J1-z","copy":"K1-z","subCopy":"L1-z","linksLeft":"M1-z","linksCenter":"N1-z","linksRight":"O1-z","link":"P1-z","onlyLink":"Q1-z"};